<template>
  <div id="profile_graph"></div>
  <!--<div v-else></div>-->
</template>
<script>
/* globals window, requestAnimationFrame */
import Highcharts from 'highcharts'
require('highcharts-multicolor-series')(Highcharts);
import { mapGetters } from 'vuex'

export default { // TODO
  data () {
    return {
      mounted: false,
      profile: {},
      athletes: {},
      checkPoints: {},
      route: {},
      selected: '',
      drawn: false
    }
  },
  computed: {
    ...mapGetters({
      profileData: 'profile',
      mobile: 'mobile',
      checkpoint: 'checkpoints',
      focusedRace: 'focusedRace',
      favourites: 'favourites',
      getAthletes: 'athletes',
      routeProfile: 'routeProfile',
      routeZones: 'routeZones',
      checkpointProfile: 'checkpointProfile'
    }),
    filteredAthletes: function () {
      let temp = []
      for (let raid in this.getAthletes) {
        if (this.getAthletes[raid].withdrawn_at === null && !this.getAthletes[raid].isFinished && this.getAthletes[raid].properties.duration > 0) {
          let name = this.getAthletes[raid].team_id === null ? this.getAthletes[raid].first_name + ' ' + this.getAthletes[raid].last_name : this.getAthletes[raid].team.name
          temp.push({
            name: name,
            id: this.getAthletes[raid].id,
            y: this.getAthletes[raid].properties.elevation,
            x: this.getAthletes[raid].properties.distance / 1000,
            marker: this.getAthleteMarker(this.getAthletes[raid])
          })
        }
      }
      return temp
    }
  },
  mounted () {
    this.mounted = true
    this.drawn = true
    this.setupProfile()
    this.drawProfile()
    this.drawCheckpoints()
  },
  watch: {
    focusedRace: function (value) {
      if (this.mounted) {
        this.athletes.data = this.filteredAthletes
        if (this.profile.get('athletes')) {
          this.profile.get('athletes').update(this.athletes)
        }
        for (var i = 0; i < this.route.length; i++) {
          let routeId = this.route[i].id
          if (this.profile.get(routeId)) {
            this.profile.get(routeId).update(this.route[i])
          } else {
            this.profile.addSeries(this.route[i])
          }
        }
        if (this.profile.get('route')) {
          this.profile.get('route').update(this.route)
        }
        if (this.profile.get('checkpoints')) {
          this.profile.get('checkpoints').update(this.checkPoints)
        }
      }
    },
    '$route': function (to, from) {
      if (to.name === 'athlete') {
        this.selected = to.params.id
      } else {
        this.selected = to.name
      }
      if (to.name === 'details' || from.name === 'details') {
        // this.profile.reflow()
      }
    },
    filteredAthletes () {
      if (this.profile.get('athletes')) {
        this.athletes.data = this.filteredAthletes
        this.profile.get('athletes').update(this.athletes)
      } else {
        this.athletes.data = this.filteredAthletes
        this.profile.addSeries(this.athletes)
      }
    },
    routeProfile () {
      if (this.mounted) {
        this.drawProfile()
      }
    },
    checkpointProfile () {
      if (this.mounted) {
        this.drawCheckpoints()
      }
    }
  },
  methods: {
    setupProfile: function () {
      let self = this
      let container = document.getElementById('profile_graph')
      let options = {
        chart: {
          renderTo: container,
          panning: true,
          panKey: 'shift',
          backgroundColor: 'rgba(0, 0, 0, 0)',
          zoomType: 'x'
        },
        title: {
          text: null
        },
        credits: {
          enabled: false
        },
        xAxis: {
          tickColor: '#000000',
          labels: {
            format: '{value} km'
          },
          crosshair: {
            snap: true
          }
        },
        yAxis: {
          title: {
            text: null
          },
          crosshair: {
            snap: true
          },
          labels: {
            format: '{value} m'
          }
        },
        legend: {
          enabled: false
        },
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              yAxis: {
                labels: {
                  align: 'left',
                  x: 0,
                  y: 0
                },
                title: {
                  text: null
                }
              },
              subtitle: {
                text: null
              }
            }
          }]
        }
      }
      if (this.mobile) {
        let width = window.innerWidth
        options.chart.width = width
      }
      this.profile = new Highcharts.Chart(options)
      this.route = {
        type: 'line',
        id: 'route',
        zIndex: 1,
        zoneAxis: 'x',
        turboThreshold: 0,
        animation: false,
        tooltip: {
          enabled: true,
          headerFormat: null,
          pointFormatter: function () {
            return 'Altitude: ' + this.y + ' m<br>Distance: ' + Math.round(this.x * 10) / 10 + ' km'
          }
        }
      }
      this.athletes = {
        type: 'scatter',
        cursor: 'pointer',
        id: 'athletes',
        animation: false,
        zIndex: 2,
        marker: {
          fillColor: '#FFFF00',
          symbol: 'circle', // Can us 'url(place url here)'
          radius: 5
        },
        events: {
          click: function (event) {
            self.$store.dispatch('focusAthlete', event.point.id)
            self.$ma.trackEvent({category: 'Click', action: 'Profile interact athlete: ' + event.point.id, label: 'Loaded', value: ''})
            if (self.mobile) {
              self.$router.push({name: 'mathlete', params: { id: event.point.id }})
            } else {
              self.$router.push({name: 'athlete', params: { id: event.point.id }})
            }
          }
        },
        tooltip: {
          enabled: true,
          headerFormat: null,
          pointFormatter: function () {
            return '<b>' + this.name + '</b>'
          }
        }
      }
      this.checkPoints = {
        type: 'scatter',
        cursor: 'pointer',
        id: 'checkpoints',
        animation: false,
        zIndex: 3,
        marker: {
          fillColor: '#000000',
          symbol: 'circle', // Can us 'url(place url here)'
//          symbol: 'url(http://d3nv7i3620sxr0.cloudfront.net/img/icon-map-timepoint.png)',
          height: 22,
          width: 18,
          radius: 5
        },
        events: {
          click: function (event) {
            self.$store.dispatch('focusCP', event.point.cp_id)
            self.$ma.trackEvent({category: 'Click', action: 'Profile interact CP: ' + event.point.cp_id, label: 'Loaded', value: ''})
            if (self.mobile) {
              self.$router.push({name: 'mcheckpoint', params: { id: event.point.cp_id }})
            } else {
              self.$router.push({name: 'checkpoint', params: { id: event.point.cp_id }})
              self.$router.push({name: 'checkpoint', params: { id: event.point.cp_id }})
            }
          }
        },
        tooltip: {
          enabled: true,
          headerFormat: null,
          pointFormatter: function () {
            return '<b>' + this.cp_name + '</b><br/>Altitude: ' + this.y + '<br/>Distance: ' + this.x
          }
        }
      }
    },
    drawProfile: function () {
      this.route.data = this.routeProfile.data;
      this.route.zones = this.routeProfile.zones;
      if (this.profile.get('route')) {
        this.profile.get('route').update(this.route)
      } else {
        this.profile.addSeries(this.route)
      }
    },
    drawCheckpoints: function() {
      this.checkPoints.data = this.checkpointProfile;
      if (this.profile.get('checkpoints')) {
        this.profile.get('checkpoints').update(this.checkPoints)
      } else {
        this.profile.addSeries(this.checkPoints)
      }
    },
    getAthleteMarker(athlete) {
      if (athlete.id === this.selected) {
          return  {
            symbol: athlete.gender === 'male'
              ? 'url(https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-male-selected.png)'
              : 'url(https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-female-selected.png)',
            width: 50,
            height: 50
          }
      } else if (this._.indexOf(this.favourites, athlete.id) >= 0) {
        return {
            symbol: athlete.gender === 'male'
              ? 'url(https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-favourite-male.png)'
              : 'url(https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-favourite-female.png)',
            width: 15,
            height: 15
          }
      } else {
        return {
            symbol: athlete.gender === 'male'
              ? 'url(https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-male.png)'
              : 'url(https://d3nv7i3620sxr0.cloudfront.net/img/icon-map-female.png)',
            width: 15,
            height: 15
          }
      }
    }
  }
}
</script>

<style >
.area {
  fill: #76BF8A
}
.line {
  stroke: #4F7F5C;
  stroke-width: 1px;
  fill: none;
}
.selector {
  stroke: #28402E;
  stroke-width: 3px;
  fill: none;
}
#profile_graph{
  height: 180px;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/profile.vue